import React from 'react';
import { FaUsers, FaLightbulb, FaHandshake, FaChartLine } from 'react-icons/fa';
import HeaderComponent from "../Header/header.component";
import FooterComponent from "../Footer/footer.component";
import './about-us.styles.css';

const AboutUsTemplate = () => {
    const teamMembers = [
        {
            name: 'John Doe',
            position: 'CEO & Founder',
            image: 'https://randomuser.me/api/portraits/men/1.jpg',
            bio: '10+ years of experience in the industry.'
        },
        {
            name: 'Jane Smith',
            position: 'CTO',
            image: 'https://randomuser.me/api/portraits/women/1.jpg',
            bio: 'Technology enthusiast with expertise in modern web development.'
        },
        {
            name: 'Mike Johnson',
            position: 'Lead Developer',
            image: 'https://randomuser.me/api/portraits/men/2.jpg',
            bio: 'Full-stack developer with a focus on user experience.'
        }
    ];

    return (
        <main>
            <section className="ds-container" style={{ paddingTop: 24 }}>
                <div className="ds-hero">
                    <div className="ds-hero-inner">
                        <p className="ds-eyebrow" style={{ color: "var(--brand-teal)" }}>About us</p>
                        <h1 style={{ font: "var(--fw-bold) var(--t-title1) var(--font-display)" }}>
                            Sourcing electronics,<br />made simple<span className="dot">.</span>
                        </h1>
                        <p>Driving innovation and excellence in every solution we deliver. We are committed to providing top-quality services to our clients worldwide.</p>
                    </div>
                    <img className="glyph" src="/assets/img/logo-360-mark.svg" alt="" />
                </div>
            </section>

            <section className="ds-container ds-section-sm">
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <p className="ds-eyebrow">Our story</p>
                    <h2>Who we are</h2>
                </div>
                <div className="ds-card-grid cols-3">
                    <div className="ds-panel ds-panel-p">
                        <h3>Who We Are</h3>
                        <p className="ds-muted ds-mt-l">Founded in 2023, our company has been at the forefront of delivering cutting-edge solutions to businesses worldwide. We believe in the power of technology to transform businesses and improve lives.</p>
                    </div>
                    <div className="ds-panel ds-panel-p">
                        <h3>Our Mission</h3>
                        <p className="ds-muted ds-mt-l">To empower businesses through innovative technology solutions that drive growth, efficiency, and success in an ever-evolving digital landscape.</p>
                    </div>
                    <div className="ds-panel ds-panel-p">
                        <h3>Our Vision</h3>
                        <p className="ds-muted ds-mt-l">To be the most trusted and innovative technology partner for businesses seeking digital transformation and sustainable growth.</p>
                    </div>
                </div>
            </section>

            <section className="ds-container ds-section-sm" style={{ paddingBottom: 56 }}>
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <p className="ds-eyebrow">What we value</p>
                    <h2>Our values</h2>
                </div>
                <div className="ds-card-grid cols-4">
                    <div className="ds-category-card"><span className="ds-cat-ico"><FaUsers /></span><h4>Customer Focus</h4><p>We put our customers at the heart of everything we do.</p></div>
                    <div className="ds-category-card"><span className="ds-cat-ico"><FaLightbulb /></span><h4>Innovation</h4><p>We embrace creativity and continuously seek new ways to solve complex problems.</p></div>
                    <div className="ds-category-card"><span className="ds-cat-ico"><FaHandshake /></span><h4>Integrity</h4><p>We conduct our business with honesty, transparency and the highest ethical standards.</p></div>
                    <div className="ds-category-card"><span className="ds-cat-ico"><FaChartLine /></span><h4>Excellence</h4><p>We are committed to delivering exceptional quality in everything we do.</p></div>
                </div>
            </section>
        </main>
    );
};

export default AboutUsTemplate;